// extracted by mini-css-extract-plugin
export var contact = "hero-physiolymp-module--contact--Ad569";
export var cursor = "hero-physiolymp-module--cursor--EHxsh";
export var logo = "hero-physiolymp-module--logo--nsSjw";
export var text = "hero-physiolymp-module--text--ZAACs";
export var ttext = "hero-physiolymp-module--ttext--l4dft";